import React, { Component } from 'react';
import LoadingDots from '../../components/Loadingdot/Loadingdots';
import './style.css';

class GiftCouponOnlinePayment extends Component {
  constructor(props){
    super(props)

    this.state={
      showDivVerifyRejectBtn: true,
      paymentType:'',
      showVerifyBtn: true,
      showRejectBtn: true,
     
    };
    this.showPaymentRequest = this.showPaymentRequest.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.verifyPaypal = this.verifyPaypal.bind(this);
    this.rejectPaypal = this.rejectPaypal.bind(this);
    this.GiftCouponPaymentPayNow = this.GiftCouponPaymentPayNow.bind(this);
    this.getCouponsToAsigntoUserByAdmin = this.getCouponsToAsigntoUserByAdmin.bind(this);
}
componentDidMount(){
  if(this.props.userGiftcouponOnlineTransactionSuccess){
    this.setState({paymentStatus : this.props.userGiftcouponOnlineTransactionData.currentPay.paymentStatus,
      paymentType : this.props.userGiftcouponOnlineTransactionData.currentPay.paymentType,
      
    });
  }
}

componentWillReceiveProps(nextprops){
  if(nextprops.giftCouponOnlineVerifySuccess === true){
    if(nextprops.giftCouponOnlineVerifymessage){
      this.setState({ showDivVerifyRejectBtn : false });
      alert(nextprops.giftCouponOnlineVerifymessage);
      this.props.stopGiftCouponOnlineVerifyMessage();
    }   
  }else{
    if(nextprops.giftCouponOnlineVerifymessage){
      alert(nextprops.giftCouponOnlineVerifymessage);
      this.setState({ hideDispayVerify : "none" });
      this.props.stopGiftCouponOnlineVerifyMessage();
    }
  }
  if(nextprops.giftCouponRejectSuccess){
    if(nextprops.giftCouponRejectmessage){
      this.setState({ showDivVerifyRejectBtn : false });
      alert(nextprops.giftCouponRejectmessage);
      this.props.stopGiftCouponOnlineVerifyMessage();
      this.props.showPaymentRequest();
    }
  }else{
    if(nextprops.giftCouponRejectmessage){
      this.setState({ showDivVerifyRejectBtn : false });
      alert(nextprops.giftCouponRejectmessage);
      this.props.stopGiftCouponOnlineVerifyMessage();
      this.props.showPaymentRequest();
    }
  }
}

handleChange(e){
  this.setState({ comment : e.target.value});
    this.setState({showVerifyBtn : false,showRejectBtn : false });
}

showPaymentRequest(){
  this.props.showPaymentRequest();
}

verifyPaypal(){
  let data ={};
  data.transactionID = this.props.userGiftcouponOnlineTransactionData.currentPay._id;
  data.totalAmount = this.props.userGiftcouponOnlineTransactionData.currentPay.totalAmount;
  data.totalPoints = this.props.userGiftcouponOnlineTransactionData.currentPay.totalPoints;
  data.userID = this.props.userGiftcouponOnlineTransactionData.currentPay.user_id;
  data.paymentType = this.props.userGiftcouponOnlineTransactionData.currentPay.paymentType;
  data.deliveryType = this.props.userGiftcouponOnlineTransactionData.currentPay.deliveryType;
  data.comment = this.state.comment;
  let adminToken=sessionStorage.getItem("adminToken");
  data.token = adminToken;
  this.props.verifyGiftCouponOnline(data);
  this.setState({ comment : ""});
}

rejectPaypal(){
  let data ={};
  data.transactionID = this.props.userGiftcouponOnlineTransactionData.currentPay._id;    
  data.userID = this.props.userGiftcouponOnlineTransactionData.currentPay.user_id;
  data.comment = this.state.comment;
  let adminToken=sessionStorage.getItem("adminToken");
  data.token = adminToken;
  this.props.rejectGiftCouponOnline(data);
  this.setState({ comment : ""});
}
 

GiftCouponPaymentPayNow(){
  let data ={};
  data.transactionID = this.props.userGiftcouponOnlineTransactionData.currentPay._id;    
  data.userID = this.props.userGiftcouponOnlineTransactionData.currentPay.user_id;
  data.totalAmount = this.props.userGiftcouponOnlineTransactionData.currentPay.totalAmount;
  data.totalPoints = this.props.userGiftcouponOnlineTransactionData.currentPay.totalPoints;
  alert('GiftCouponPaymentPayNow');
   //this.props.GiftCouponOnlinePaymentPayUser(data);
}

getCouponsToAsigntoUserByAdmin(){
  this.props.getCouponsToAsigntoUserByAdmin();
}
  render(){

    let showLastPayment = "";
    let showReqPayment = "";
    if(this.props.userGiftcouponOnlineTransactionSuccess){
      if(this.props.userGiftcouponOnlineTransactionData.successPay){
        showLastPayment = 
        <div>
          <h4>Last success payment :</h4>
           &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  Amount :  {this.props.userGiftcouponOnlineTransactionData.successPay.totalAmount},&nbsp;USD&nbsp;&nbsp;&nbsp;  Points : {this.props.userGiftcouponOnlineTransactionData.successPay.totalPoints}                 
        </div>
      }


      if(this.props.userGiftcouponOnlineTransactionData.currentPay){
        showReqPayment = 
        <div><h4>Current Transaction:</h4>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Requested Amount :  {this.props.userGiftcouponOnlineTransactionData.currentPay.totalAmount} &nbsp; USD,&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Total points : {this.props.userGiftcouponOnlineTransactionData.currentPay.totalPoints}<br/>
        </div>
      }
    }


    let showVerifyRejectButton = "";
    if(this.state.showDivVerifyRejectBtn && this.state.paymentStatus === "pending"){
      showVerifyRejectButton = <div>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<textarea name="comment"
                  onChange={this.handleChange}
                  placeholder = "Please enter comments"
                  value={this.state.comment}/><br/>
        <div className = "VerifyRejectDiv" style={{display: this.state.hideDispayVerify }}><button  disabled = {this.state.showVerifyBtn} onClick = {this.verifyPaypal}>Verify</button></div>   
        <div className = "VerifyRejectDiv"><button  disabled = {this.state.showRejectBtn} onClick = {this.rejectPaypal}>Reject</button></div>
      </div>
      }else if(this.state.paymentStatus === "approved"){
        showVerifyRejectButton = <div className = "VerifyRejectDiv"><button   onClick = {this.getCouponsToAsigntoUserByAdmin}>AssignCoupon</button></div>
      }else{
        showVerifyRejectButton = <div className = "VerifyRejectDiv"><button   onClick = {this.getCouponsToAsigntoUserByAdmin}>AssignCoupon</button></div>
      }


    

    return (
      <div className = "regPage">
       <div className = "form">
        <div className = "GNNheading"><h1>Coupon Distribution</h1></div> 
          <br/><button  className = "backbutton" onClick = {this.showPaymentRequest} >Back</button><br/>  
          <div className = "registerform">       
            {showLastPayment}
            {showReqPayment}
            {showVerifyRejectButton}
          </div>
        </div>
      </div>
    );
  }
}
export default GiftCouponOnlinePayment;



// WEBPACK FOOTER //
// ./src/components/PaymentRequest/giftCouponOnline.js